import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AlertService} from 'src/app/services/alert.service';
import {UserService} from 'src/app/services/user-services/user.service';
import { NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import {CareService} from 'src/app/admin/admin-services/care.service';
import {AdminUserService} from '../../admin-services/admin-user.service';
import {User} from '../../../models/user';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AvatarFillerComponent } from '../../../shared/components/ux/avatar-filler/avatar-filler.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-basic-informations',
    templateUrl: './basic-informations.component.html',
    styleUrls: ['./basic-informations.component.scss'],
    standalone: true,
    imports: [NgIf, AvatarFillerComponent, MatMenuModule, MatIconModule, NgbPopoverModule, ClipboardModule, MatFormFieldModule, MatInputModule, FormsModule, NgxIntlTelInputModule]
})
export class BasicInformationsComponent implements OnInit {


  @Input() type: string;
  @Input() user;

  currentUser: User;

  updateType:string|null;
  updateForm:string|null;

  constructor(
    private userService: UserService,
    private alertService: AlertService,
    private router: Router,
    private modalService: NgbModal,
    private careService: CareService,
    private adminUserService: AdminUserService,
  ) { }

  ngOnInit(): void {

    this.currentUser = this.userService.getInfos();
  }

/*****************************************************************************************************************************************/
/*************************************************** FONCTION GESTION USER ***************************************************************/
/*****************************************************************************************************************************************/



    // Supprime l'utilisateur , a voir si on envoi des notif, pour le moment, non
  deleteUser() {
    this.adminUserService.deleteFromCare(this.user.id).subscribe(
      (r) => {
        if(r){
          this.alertService.openSnackBar('USER.DELETE.SUCCESS', 'snack-success');
          this.router.navigate(['/admin/users']);
        }
        else{
          this.alertService.openSnackBar('USER.DELETE.ERROR', 'snack-error');
        }
      }
    )
  }

/*****************************************************************************************************************************************/
/************************************************** FONCTION GESTION PARTNER *************************************************************/
/*****************************************************************************************************************************************/

  // @TODO
  refreshHousing() : void {

  }

  // @TODO
  reset(): void {

  }

  // @TODO
  updatePartner(): void {
    let datas = {id : this.user.id };
    datas[this.updateType] = this.updateForm;
    this.careService.updatePartner(datas).subscribe(() => {
      this.alertService.openSnackBar('Le partenaire a été correctement mis à jour', 'snack-success');
    });
  }

  openModal(modal, type) : void {
    this.updateType = type;
    this.modalService.open(modal, {centered:true, size:'md'})
  }






}
